import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 親ID
 */
export class ParentId extends PrimitiveValueObject<string> {
  /**
   * 作成する
   * @param value 値
   * @returns 値
   */
  static create(value: string): ParentId {
    return new ParentId(value);
  }
}
